export enum StatusEnm {
  '下线',
  '上线',
}

const arr = Object.keys(StatusEnm).map((item) => {
  const key = isNaN(Number(item)) ? item : Number(item);
  return [key as string, StatusEnm[item] as StatusEnm];
});

export const StatusMap = new Map(arr);

export interface PushItem {
  id: number;
  imageUrl: string;
  status: StatusEnm;
  createTime: string;
  jumpContent: string;
  updateTime: string;
  updateUser: string;
}

export interface PushListResponse {
  records: PushItem[];
  total: number;
}

export interface ISearchParams {
  currentPage?: number; // 当前页
  pageSize?: number; // 每页条数
}
